// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__19bZ6","inner":"Footer_inner__2VBBJ"};